import { OverallDimensionsInformationFieldNames } from '@contracts/order/fields/OverallDimensionsInformationFields';
import {
  LoadHeightField,
  LoadLengthField,
  LoadWidthField,
} from '@src/permitField/LoadInformationFields';
import {
  PositiveFloatField,
  ZeroOrPositiveFloatField,
} from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class OverallLengthField extends PositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallLength;
  public static validator = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .required()
    .test({
      name: 'isMinLoad',
      message: 'isMinLoad',
      test(value, context) {
        const schema = context.from?.[0]?.schema;
        const schemaFields =
          schema && 'fields' in schema
            ? (schema.fields as Record<string, unknown>)
            : undefined;
        const isLoadLengthInSchema =
          schemaFields?.[LoadLengthField.fieldName] !== undefined;

        if (!isLoadLengthInSchema) {
          return true;
        }

        const loadLength = context.parent[LoadLengthField.fieldName];
        if (loadLength === undefined || loadLength === null) {
          return true;
        }
        return value !== undefined && value !== null && value >= loadLength;
      },
    });
}

export class OverallHeightField extends PositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallHeight;
  public static validator = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .required()
    .test({
      name: 'isMinLoad',
      message: 'isMinLoad',
      test(value, context) {
        const schema = context.from?.[0]?.schema;
        const schemaFields =
          schema && 'fields' in schema
            ? (schema.fields as Record<string, unknown>)
            : undefined;
        const isLoadHeightInSchema =
          schemaFields?.[LoadHeightField.fieldName] !== undefined;

        if (!isLoadHeightInSchema) {
          return true;
        }

        const loadHeight = context.parent[LoadHeightField.fieldName];
        if (loadHeight === undefined || loadHeight === null) {
          return true;
        }
        return value !== undefined && value !== null && value >= loadHeight;
      },
    });
}

export class OverallWidthField extends PositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallWidth;
  public static validator = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .required()
    .test({
      name: 'isMinLoad',
      message: 'isMinLoad',
      test(value, context) {
        const schema = context.from?.[0]?.schema;
        const schemaFields =
          schema && 'fields' in schema
            ? (schema.fields as Record<string, unknown>)
            : undefined;
        const isLoadWidthInSchema =
          schemaFields?.[LoadWidthField.fieldName] !== undefined;

        if (!isLoadWidthInSchema) {
          return true;
        }

        const loadWidth = context.parent[LoadWidthField.fieldName];
        if (loadWidth === undefined || loadWidth === null) {
          return true;
        }
        return value !== undefined && value !== null && value >= loadWidth;
      },
    });
}

export class OverallWeightField extends PositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallWeight;
}

export class OverallFrontOverhangField extends ZeroOrPositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallFrontOverhang;
}

export class OverallRearOverhangField extends ZeroOrPositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallRearOverhang;
}

export class OverallEFFOverhangField extends ZeroOrPositiveFloatField {
  public static fieldName: string =
    OverallDimensionsInformationFieldNames.OverallEFFOverhang;
}

export const overallDimensionsFields = {
  [OverallLengthField.fieldName]: OverallLengthField.validator,
  [OverallHeightField.fieldName]: OverallHeightField.validator,
  [OverallWidthField.fieldName]: OverallWidthField.validator,
  [OverallWeightField.fieldName]: OverallWeightField.validator,
  [OverallFrontOverhangField.fieldName]: OverallFrontOverhangField.validator,
  [OverallRearOverhangField.fieldName]: OverallRearOverhangField.validator,
  [OverallEFFOverhangField.fieldName]: OverallEFFOverhangField.validator,
};
